import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { SignIn } from '@pages/sign-in';
import { SignUp } from '@pages/sign-up';
import { ForgotPassword } from '@pages/forgot-password';
import { Users } from '@pages/users';
import { UsersMachine } from '@pages/users-machine';
import { CercaVirtual } from '@pages/cerca-virtual';
import { Devices } from '@pages/devices';
import { Equipaments } from '@pages/equipaments';
import { OperationDashboard } from '@pages/dashboard';
import { EquipamentDashboard } from '@pages/equipament-dashboard';
import { MachineUsersDashboard } from '@pages/machine-users-dashboard';
import { MaintenanceReports } from '@pages/maintenance';
import { EventReports } from '@pages/events';
import { ChecklistReports } from '@pages/checklist';
import { RemoteBlocking } from '@pages/remote-blocking';
import { ChecklistConfigPage } from '@pages/checklist-config';
import { ChecklistAssignmentPage } from '@pages/checklist-assignment';
import { FirmwareAssignmentPage } from '@pages/firmware-assignment';
import { OperationsSetupPage } from '@pages/operations-setup';
import { OperationsConfigPage } from '@pages/operations-config';
import { AuditHistoryPage } from '@pages/audit-history';
import { TicketSystemPage } from '@pages/ticket-system';
import { DebugFirmwarePage } from '@pages/debug-firmware';
import { ImuDiagnosticsPage } from '@pages/imu-diagnostics';
import { AdminTidsPage } from '@pages/admin-tids';
import { TvDashboard } from '@pages/tv-dashboard';
import { ThemeProvider } from './theme';

const queryClient = new QueryClient();

function Navigation() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users-machine" element={<UsersMachine />} />
        <Route path="/cerca-virtual" element={<CercaVirtual />} />
        <Route path="/devices" element={<Devices />} />
        <Route path="/operation-dashboard" element={<OperationDashboard />} />
        <Route path="/equipaments" element={<Equipaments />} />
        <Route path="/equipament-dashboard" element={<EquipamentDashboard />} />
        <Route path="/machine-users-dashboard" element={<MachineUsersDashboard />} />
        <Route path="/events-reports" element={<EventReports />} />
        <Route path="/checklist-reports" element={<ChecklistReports />} />
        <Route path="/maintenance-reports" element={<MaintenanceReports />} />
        <Route path="/remote-blocking" element={<RemoteBlocking />} />
        <Route path="/checklist-config" element={<ChecklistConfigPage />} />
        <Route path="/checklist-assignment" element={<ChecklistAssignmentPage />} />
        <Route path="/firmware-assignment" element={<FirmwareAssignmentPage />} />
        <Route path="/operations-setup" element={<OperationsSetupPage />} />
        <Route path="/operations-config" element={<OperationsConfigPage />} />
        <Route path="/audit-history" element={<AuditHistoryPage />} />
        <Route path="/ticket-system" element={<TicketSystemPage />} />
        <Route path="/debug-firmware" element={<DebugFirmwarePage />} />
        <Route path="/imu-diagnostics" element={<ImuDiagnosticsPage />} />
        <Route path="/admin-tids" element={<AdminTidsPage />} />
        <Route path="/tv" element={<TvDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <CssBaseline />
        <Navigation />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
